import React from 'react';
import MessagingTemplatesLayout from '../../../layouts/messagingSectionLayout';
import MessagingTemplateCollection from '../../../layouts/messagingSectionLayout/messagingTemplateCollection';
import { APP_PLAYBOOK_MESSAGING_SNIPPET_FORM } from '../../../app/_constants/routes';
import { FORM_MODES, TEMPLATE_TYPES } from '../../../utils/templates.utils';
import { TYPES } from '../../../constants/templates';
import { useRouter } from '../../../hooks';
import MessagingMineSwitch from '../../../components/messagingTemplates/messagingMineSwitch/messagingMineSwitch';
import MessagingBattlecardsFilterSwitch from '../../../components/messagingTemplates/messagingBattlecardsFilterSwitch/messagingBattlecardsFilterSwitch';
import MessagingOfficialFilterSwitch from '../../../components/messagingTemplates/messagingOfficialFilterSwitch/messagingOfficialFilterSwitch';

export const SnippetTemplatesPage = () => {
  const { history } = useRouter();

  const config = {
    actionName: 'Create snippet',
    onClickAction: e =>
      history.push(`${APP_PLAYBOOK_MESSAGING_SNIPPET_FORM}?mode=${FORM_MODES.CREATION}`, {
        event: e,
      }),
    searchPlaceholder: 'Search',
  };

  return (
    <MessagingTemplatesLayout
      dataIntercom="account-settings-pitch-template-page"
      body={<MessagingTemplateCollection templateType={TEMPLATE_TYPES.SNIPPET} />}
      actions={
        <>
          <MessagingOfficialFilterSwitch />
          <MessagingBattlecardsFilterSwitch />
          <MessagingMineSwitch />
        </>
      }
      type={TYPES.SNIPPET}
      id="SNIPPET_MESSAGING_TEMPLATES"
      title="Snippets"
      createConfig={config}
      pluralEntityName="Snippet templates"
    />
  );
};
